var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lists",domProps:{"innerHTML":_vm._s(this.block.saveContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }